import { Box, Button, Grid, Typography } from '@mui/material';
import CustomInput from 'components/CustomInput/customInput';
import CustomSelect from 'components/CustomSelect/customSelect';
import _ from 'lodash';
// import Multiselect from 'multiselect-react-dropdown';
import React, { FC, useCallback, useEffect } from 'react';
import { Controller } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import { getAllListData } from 'services/CommonServices';
import { SETUP_ENDPOINT } from 'utils/Constant';

import useStyles from '../../../PrivateStyle';
import QuestionAndIssues from './QuestionAndIssues';

type LeadThreeProps = {
  control;
  errors;
  setValue;
  watch;
  handleSubmit;
  cancelForm;
  onSubmitForm: (src: any) => void;
  firmData?: any;
  processingTypes?: any;
  filingTypes?: any;
  visaTypes?: any;
  attorneyContactPersonList?: any;
  setAttorneyContactPersonList?: any;
  attorneyInitDetails?: any;
  setAttorneyInitDetails?: any;
  attorneySupportIds?: any;
  setAttorneySupportIds?: any;
  additionalAttorneyContactIds?: any;
  setAdditionalAttorneyContactIds?: any;
  editId?: string;
  attorneyList: Array<any>;
  leadData?: any;
};

const AttorneyForm: FC<LeadThreeProps> = ({
  control,
  errors,
  setValue,
  watch,
  handleSubmit,
  cancelForm,
  onSubmitForm,
  visaTypes,
  filingTypes,
  processingTypes,
  attorneyContactPersonList,
  setAttorneyContactPersonList,
  attorneyInitDetails,
  setAttorneyInitDetails,
  attorneySupportIds,
  setAttorneySupportIds,
  additionalAttorneyContactIds,
  setAdditionalAttorneyContactIds,
  attorneyList,
  editId,
  leadData,
}) => {
  const classes = useStyles();
  const multiselectRef = React.createRef<any>();
  const multiselectRef1 = React.createRef<any>();

  const resetFields = useCallback(
    (otherFieldReset: boolean) => {
      // setValue('attorneyContactId', null);
      setAttorneyInitDetails((pre) => ({
        ...pre,
        attorneyCountryCode: '+1',
        attorneyEmail: '',
        attorneyPosition: '',
        attorneyTelephone: '',
      }));
      if (otherFieldReset) {
        setValue('attorneySupport', null);
        setValue('caseManager', null);
        setValue('additionalAttorneyContacts', null);
        multiselectRef &&
          multiselectRef.current &&
          multiselectRef.current.resetSelectedValues();
        multiselectRef1 &&
          multiselectRef1.current &&
          multiselectRef1.current.resetSelectedValues();
      }
    },
    [multiselectRef, multiselectRef1, setAttorneyInitDetails, setValue],
  );
  const getAttorneyContactDetails = useCallback(
    (attorneyId: string, otherFieldReset?: boolean) => {
      resetFields(otherFieldReset);
      if (!attorneyId) {
        setAttorneyContactPersonList([]);
        return;
      }
      getAllListData(
        `${SETUP_ENDPOINT.SelectMenu}/lawfirm/${String(attorneyId)}`,
      ).then((contactResp: any) => {
        setAttorneyContactPersonList(contactResp);
        const hasContactAttorney = contactResp.find(
          (contact) =>
            !contact.primary_contact &&
            contact.id === watch('attorneyContactId'),
        );
        const hasPrimaryContact = contactResp.find(
          (contact) => contact.primary_contact,
        );

        if (!_.isEmpty(hasContactAttorney)) {
          setValue('attorneyContactId', hasContactAttorney.id);
          setAttorneyInitDetails((pre) => ({
            ...pre,
            attorneyCountryCode: hasContactAttorney.country_code_mobile
              ? hasContactAttorney.country_code_mobile
              : '+1',
            attorneyEmail: hasContactAttorney.email_id,
            attorneyPosition: hasContactAttorney.designation
              ? hasContactAttorney.designation
              : '',
            attorneyTelephone: hasContactAttorney.contact_mobile
              ? String(hasContactAttorney.contact_mobile).indexOf('+') !== -1
                ? hasContactAttorney.contact_mobile
                : hasContactAttorney.country_code_mobile
                ? String(hasContactAttorney.country_code_mobile)
                    .concat(' ')
                    .concat(hasContactAttorney.contact_mobile)
                : hasContactAttorney.mobile_country_code
                ? String(hasContactAttorney.mobile_country_code)
                    .concat(' ')
                    .concat(hasContactAttorney.contact_mobile)
                : '+1 '.concat(hasContactAttorney.contact_mobile)
              : '',
          }));
        }
        if (
          _.isUndefined(hasContactAttorney) &&
          !_.isEmpty(hasPrimaryContact)
        ) {
          setValue('attorneyContactId', hasPrimaryContact.id);
          setAttorneyInitDetails((pre) => ({
            ...pre,
            attorneyCountryCode: hasPrimaryContact.country_code_mobile
              ? hasPrimaryContact.country_code_mobile
              : '+1',
            attorneyEmail: hasPrimaryContact.email_id,
            attorneyPosition: hasPrimaryContact.designation
              ? hasPrimaryContact.designation
              : '',
            attorneyTelephone: hasPrimaryContact.contact_mobile
              ? String(hasPrimaryContact.contact_mobile).indexOf('+') !== -1
                ? hasPrimaryContact.contact_mobile
                : hasPrimaryContact.country_code_mobile
                ? String(hasPrimaryContact.country_code_mobile)
                    .concat(' ')
                    .concat(hasPrimaryContact.contact_mobile)
                : hasPrimaryContact.mobile_country_code
                ? String(hasPrimaryContact.mobile_country_code)
                    .concat(' ')
                    .concat(hasPrimaryContact.contact_mobile)
                : '+1 '.concat(hasPrimaryContact.contact_mobile)
              : '',
          }));
        }
        if (!otherFieldReset) {
          const filterSupprotValues =
            contactResp &&
            contactResp.length &&
            watch('attorneySupport') &&
            watch('attorneySupport').length
              ? contactResp.filter((e) =>
                  watch('attorneySupport').includes(e.id),
                )
              : [];
          const filterAdditionalSupportValues =
            contactResp &&
            contactResp.length &&
            watch('additionalAttorneyContacts') &&
            watch('additionalAttorneyContacts').length
              ? contactResp.filter((e) =>
                  watch('additionalAttorneyContacts').includes(e.id),
                )
              : [];
          setAttorneySupportIds(filterSupprotValues);
          setAdditionalAttorneyContactIds(filterAdditionalSupportValues);
        }
      });
    },
    [
      resetFields,
      setAdditionalAttorneyContactIds,
      setAttorneyContactPersonList,
      setAttorneyInitDetails,
      setAttorneySupportIds,
      setValue,
      watch,
    ],
  );

  useEffect(() => {
    if (watch('attorneyId')) getAttorneyContactDetails(watch('attorneyId'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Typography component={'div'}>
      <form id="lead-step-three" onSubmit={handleSubmit(onSubmitForm)}>
        <Typography component={'div'} sx={{ marginTop: '1rem !important' }}>
          <Typography component={'div'} className={classes.leadwiteBox}>
            <Typography
              component={'div'}
              className="uadd-title"
              sx={{
                paddingTop: 'unset !important',
              }}>
              Lead
            </Typography>
            <Grid container>
              <Grid item md={12}>
                <Box
                  component="form"
                  className="lead-box"
                  style={{ padding: '1rem !important' }}
                  noValidate
                  autoComplete="off">
                  <Grid container columnSpacing={{ md: 2, sm: 1 }}>
                    <Grid item md={6}>
                      <Typography
                        component={'div'}
                        className="custom-field-row"
                        style={{ marginBottom: '0px !important' }}>
                        <Typography
                          component={'div'}
                          className="custom-label"
                          sx={{ margin: '.5rem 0 0 0 !important' }}>
                          Visa Type
                        </Typography>
                        <Controller
                          control={control}
                          defaultValue={''}
                          name={'visaType'}
                          render={({
                            field: { onChange, value, name, ref },
                            formState,
                          }) => {
                            return (
                              <CustomSelect
                                labelKey={'visa_code'}
                                valueKey={'visa_id'}
                                options={!_.isEmpty(visaTypes) ? visaTypes : []}
                                name={name}
                                value={value}
                                onChange={(e) => {
                                  onChange(e);
                                }}
                                placeHolder={'Select'}
                                className={'custom-input'}
                                error={errors.visaType?.message}
                                searchable={true}
                                disabled={leadData?.isAffilateCase}
                              />
                            );
                          }}
                        />
                      </Typography>
                      <Typography
                        component={'div'}
                        className="custom-field-row"
                        style={{ marginBottom: '0px !important' }}>
                        <Typography component={'div'} className="custom-label">
                          Status
                        </Typography>
                        <Controller
                          control={control}
                          defaultValue="prospect"
                          name={'leadStatus'}
                          render={({
                            field: { onChange, value, name, ref },
                            formState,
                          }) => {
                            return (
                              <CustomSelect
                                labelKey={'label'}
                                valueKey={'value'}
                                options={[
                                  {
                                    label: 'Prospect',
                                    value: 'prospect',
                                  },
                                  {
                                    label: 'Ready to Contract',
                                    value: 'readyForContract',
                                  },
                                  {
                                    label: 'Contract',
                                    value: 'contract',
                                  },
                                  {
                                    label: 'Petition',
                                    value: 'petition',
                                  },
                                  {
                                    label: 'Closed',
                                    value: 'closed',
                                  },
                                ]}
                                name={name}
                                value={value}
                                onChange={onChange}
                                placeHolder={'Select'}
                                className={'custom-input'}
                                error={errors.leadStatus?.message}
                                searchable={true}
                                isClearable={false}
                                disabled={
                                  _.isUndefined(editId) ||
                                  leadData?.isAffilateCase
                                }
                              />
                            );
                          }}
                        />
                      </Typography>
                    </Grid>
                    <Grid item md={6}>
                      <Typography
                        component={'div'}
                        className="custom-field-row"
                        style={{ marginBottom: '0px !important' }}>
                        <Typography component={'div'} className="custom-label">
                          Notes
                        </Typography>
                        <Controller
                          control={control}
                          defaultValue={''}
                          name={'leadNotes'}
                          render={({
                            field: { onChange, value, name, ref },
                            formState,
                          }) => {
                            return (
                              <CustomInput
                                placeHolder={'Notes'}
                                name={name}
                                value={value}
                                className={'custom-textarea'}
                                error={errors.leadNotes?.message || ''}
                                onChange={(e) => {
                                  onChange(e);
                                }}
                                isTextArea={true}
                                minRows={6}
                                disabled={[5].includes(
                                  leadData?.affilateRoleId,
                                )}
                              />
                            );
                          }}
                        />
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Typography>
          {visaTypes &&
            Array.isArray(visaTypes) &&
            visaTypes.length &&
            visaTypes.find((e) => e.visa_id == watch('visaType'))
              ?.is_premium_processing && (
              <QuestionAndIssues
                control={control}
                errors={errors}
                setValue={setValue}
                watch={watch}
                processingTypes={processingTypes}
                filingTypes={filingTypes}
              />
            )}

          <Typography component={'div'} className={classes.leadwiteBox}>
            <Typography
              component={'div'}
              className="uadd-title"
              sx={{
                paddingTop: 'unset !important',
              }}>
              Lead Attorney
            </Typography>

            <Grid container>
              <Grid item md={12}>
                <Box
                  component="form"
                  className="lead-box"
                  sx={{ paddingRight: '20px !important' }}
                  noValidate
                  autoComplete="off">
                  <Grid container columnSpacing={{ md: 2, sm: 1 }}>
                    <Grid item md={2}>
                      <Typography
                        component={'div'}
                        className="custom-field-row"
                        style={{ marginBottom: '0px !important' }}>
                        <Typography
                          component={'div'}
                          className="custom-label"
                          sx={{ margin: '.5rem 0 0 0 !important' }}>
                          Firm Name
                        </Typography>
                        <Controller
                          control={control}
                          defaultValue={''}
                          name={'attorneyId'}
                          render={({
                            field: { onChange, value, name, ref },
                            formState,
                          }) => {
                            return (
                              <CustomSelect
                                labelKey={'firm_name'}
                                valueKey={'id'}
                                options={
                                  !_.isEmpty(attorneyList) ? attorneyList : []
                                }
                                name={name}
                                value={value}
                                onChange={(e) => {
                                  onChange(e);
                                  getAttorneyContactDetails(
                                    e.target.value,
                                    true,
                                  );
                                }}
                                placeHolder={'Select'}
                                className={'custom-input'}
                                error={errors.attorneyId?.message}
                                searchable={true}
                                disabled={
                                  editId && leadData && leadData.isAffilateCase
                                }
                              />
                            );
                          }}
                        />
                      </Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography
                        component={'div'}
                        className="custom-field-row"
                        style={{ marginBottom: '0px !important' }}>
                        <Typography
                          component={'div'}
                          className="custom-label"
                          sx={{ margin: '.5rem 0 0 0 !important' }}>
                          Contact Person
                        </Typography>
                        <Controller
                          control={control}
                          defaultValue={''}
                          name={'attorneyContactId'}
                          render={({
                            field: { onChange, value, name, ref },
                            formState,
                          }) => {
                            return (
                              <CustomSelect
                                isClearable={false}
                                labelKey={'full_name'}
                                valueKey={'id'}
                                options={
                                  !_.isEmpty(attorneyContactPersonList)
                                    ? attorneyContactPersonList
                                    : []
                                }
                                name={name}
                                value={value}
                                onChange={(e) => {
                                  onChange(e.target.value);
                                  const attorneyPerson =
                                    attorneyContactPersonList.find(
                                      (person) => person.id === e.target.value,
                                    );
                                  if (attorneyPerson) {
                                    setAttorneyInitDetails((pre) => ({
                                      ...pre,
                                      attorneyCountryCode:
                                        attorneyPerson.country_code_mobile
                                          ? attorneyPerson.country_code_mobile
                                          : '+1',
                                      attorneyEmail: attorneyPerson.email_id,
                                      attorneyPosition:
                                        attorneyPerson.designation
                                          ? attorneyPerson.designation
                                          : '',
                                      attorneyTelephone:
                                        attorneyPerson.contact_mobile
                                          ? attorneyPerson.contact_mobile
                                          : '',
                                    }));
                                  }
                                }}
                                placeHolder={'Select'}
                                className={'custom-input'}
                                error={errors.attorneyContactId?.message}
                                searchable={true}
                                disabled={leadData?.isAffilateCase}
                              />
                            );
                          }}
                        />
                      </Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography
                        component={'div'}
                        className="custom-field-row"
                        style={{ marginBottom: '0px !important' }}>
                        <Typography
                          component={'div'}
                          className="custom-label"
                          sx={{ margin: '.5rem 0 0 0 !important' }}>
                          Job Title
                        </Typography>
                        <CustomInput
                          // name={name}
                          value={
                            !_.isEmpty(attorneyInitDetails)
                              ? attorneyInitDetails.attorneyPosition
                              : ''
                          }
                          className={'custom-input'}
                          disabled={true}
                          placeHolder={'Job Title'}
                        />
                      </Typography>
                    </Grid>
                    <Grid item md={4}>
                      <Typography
                        component={'div'}
                        className="custom-field-row u-pr-1"
                        style={{ marginBottom: '0px !important' }}>
                        <Typography
                          component={'div'}
                          className="custom-label"
                          sx={{ margin: '.5rem 0 0 0 !important' }}>
                          Email
                        </Typography>
                        <CustomInput
                          // name={name}
                          value={
                            !_.isEmpty(attorneyInitDetails)
                              ? attorneyInitDetails.attorneyEmail
                              : ''
                          }
                          className={'custom-input'}
                          disabled={true}
                          placeHolder={'Email'}
                        />
                      </Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography
                        component={'div'}
                        className="custom-field-row"
                        style={{ marginBottom: '0px !important' }}>
                        <Typography
                          component={'div'}
                          className="custom-label"
                          sx={{ margin: '.5rem 0 0 0 !important' }}>
                          Phone
                        </Typography>

                        <PhoneInput
                          placeholder="Phone"
                          inputStyle={{ width: '200px' }}
                          country="us"
                          // country={
                          //   attorneyInitDetails.attorneyCountryCode
                          //     ? attorneyInitDetails.attorneyCountryCode
                          //     : 'us'
                          // }
                          value={
                            !_.isEmpty(attorneyInitDetails) &&
                            attorneyInitDetails.attorneyTelephone
                              ? String(
                                  attorneyInitDetails.attorneyTelephone,
                                ).indexOf('+') !== -1
                                ? attorneyInitDetails.attorneyTelephone
                                : attorneyInitDetails.attorneyCountryCode
                                ? String(
                                    attorneyInitDetails.attorneyCountryCode,
                                  )
                                    .concat(' ')
                                    .concat(
                                      attorneyInitDetails.attorneyTelephone,
                                    )
                                : '+1 '.concat(
                                    attorneyInitDetails.attorneyTelephone,
                                  )
                              : '+1 '
                          }
                          disabled={true}
                        />
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Typography>
          <Typography component={'div'} className={classes.leadwiteBox}>
            <Typography
              component={'div'}
              className="uadd-title"
              sx={{
                paddingBottom: 'unset !important',
                paddingTop: 'unset !important',
              }}>
              Attorney Additional Contacts
            </Typography>

            <Grid container>
              <Grid item md={12}>
                <Box
                  component="form"
                  className="lead-box"
                  sx={{ paddingRight: '20px !important' }}
                  noValidate
                  autoComplete="off">
                  <Grid container columnSpacing={{ md: 2, sm: 1 }}>
                    <Grid item md={4}>
                      <Typography
                        component={'div'}
                        className="custom-field-row"
                        style={{ marginBottom: '0px !important' }}>
                        <Typography
                          component={'div'}
                          className="custom-label"
                          sx={{ margin: '.5rem 0 0 0 !important' }}>
                          Case Manager
                        </Typography>
                        <Controller
                          control={control}
                          defaultValue={''}
                          name={'caseManager'}
                          render={({
                            field: { onChange, value, name, ref },
                            formState,
                          }) => {
                            return (
                              <CustomSelect
                                closeMenuOnSelect={false}
                                labelKey={'full_name'}
                                valueKey={'id'}
                                options={attorneyContactPersonList}
                                isMulti={true}
                                name={name}
                                value={value}
                                onChange={(e) => {
                                  onChange(e);
                                }}
                                placeHolder={'Select'}
                                className={'basic-multi-select'}
                                error={errors.caseManager?.message}
                                searchable={true}
                                disabled={leadData?.isAffilateCase}
                              />
                            );
                          }}
                        />
                      </Typography>
                    </Grid>
                    <Grid item md={4}>
                      <Typography
                        component={'div'}
                        className="custom-field-row"
                        style={{ marginBottom: '0px !important' }}>
                        <Typography
                          component={'div'}
                          className="custom-label"
                          sx={{ margin: '.5rem 0 0 0 !important' }}>
                          Support Officer
                        </Typography>
                        <Controller
                          control={control}
                          defaultValue={''}
                          name={'attorneySupport'}
                          render={({
                            field: { onChange, value, name, ref },
                            formState,
                          }) => {
                            return (
                              <CustomSelect
                                closeMenuOnSelect={false}
                                labelKey={'full_name'}
                                valueKey={'id'}
                                options={attorneyContactPersonList}
                                isMulti={true}
                                name={name}
                                value={value}
                                onChange={(e) => {
                                  onChange(e);
                                }}
                                placeHolder={'Select'}
                                className={'basic-multi-select'}
                                disabled={leadData?.isAffilateCase}
                                // error={errors.teamMembers?.message}
                                // disabled={allowAccess}
                                // />
                                // <Multiselect
                                //   {...field}
                                //   placeholder={
                                //     watch('attorneySupport')?.length === 0
                                //       ? 'Case Manager'
                                //       : ''
                                //   }
                                //   displayValue="full_name"
                                //   onSelect={(selected, item) => {
                                //     setValue(
                                //       'attorneySupport',
                                //       selected.map((support) => support.id),
                                //     );
                                //   }}
                                //   onRemove={(selected, item) => {
                                //     setValue(
                                //       'attorneySupport',
                                //       selected.map((support) => support.id),
                                //     );
                                //   }}
                                //   options={
                                //     !_.isEmpty(attorneyContactPersonList)
                                //       ? attorneyContactPersonList
                                //       : []
                                //   }
                                //   ref={multiselectRef1}
                                //   selectedValues={attorneySupportIds}
                              />
                            );
                          }}
                        />
                      </Typography>
                    </Grid>
                    <Grid item md={4}>
                      <Typography
                        component={'div'}
                        className="custom-field-row"
                        style={{ marginBottom: '0px !important' }}>
                        <Typography
                          component={'div'}
                          className="custom-label"
                          sx={{ margin: '.5rem 0 0 0 !important' }}>
                          Managing Attorney
                        </Typography>
                        <Controller
                          control={control}
                          defaultValue={''}
                          name={'additionalAttorneyContacts'}
                          render={({
                            field: { onChange, value, name, ref },
                            formState,
                          }) => {
                            return (
                              <CustomSelect
                                closeMenuOnSelect={false}
                                labelKey={'full_name'}
                                valueKey={'id'}
                                options={attorneyContactPersonList}
                                isMulti={true}
                                name={name}
                                value={value}
                                onChange={(e) => {
                                  onChange(e);
                                }}
                                placeHolder={'Select'}
                                className={'basic-multi-select'}
                                disabled={leadData?.isAffilateCase}
                                // error={errors.teamMembers?.message}
                                // disabled={allowAccess}
                              />
                              // <Multiselect
                              //   {...field}
                              //   placeholder={
                              //     watch('additionalAttorneyContacts')
                              //       ?.length === 0
                              //       ? ' Support Officer'
                              //       : ''
                              //   }
                              //   displayValue="full_name"
                              //   onSelect={(selected, item) => {
                              //     setValue(
                              //       'additionalAttorneyContacts',
                              //       selected.map((support) => support.id),
                              //     );
                              //   }}
                              //   onRemove={(selected, item) => {
                              //     setValue(
                              //       'additionalAttorneyContacts',
                              //       selected.map((support) => support.id),
                              //     );
                              //   }}
                              //   options={
                              //     !_.isEmpty(attorneyContactPersonList)
                              //       ? attorneyContactPersonList
                              //       : []
                              //   }
                              //   ref={multiselectRef}
                              //   selectedValues={additionalAttorneyContactIds}
                              // />
                            );
                          }}
                        />
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Typography>
        </Typography>
      </form>
      <Grid container className="bottom-fixed">
        <Grid item md={12}>
          <Typography component={'div'} className="d-flex-jae">
            <Button className="cancel-btn mr-2" onClick={cancelForm}>
              <Typography className="o-box" />
              Cancel
            </Button>
            {![5].includes(leadData?.affilateRoleId) ? (
              <Button
                className="add-btn"
                type="submit"
                form={'lead-step-three'}>
                Save
              </Button>
            ) : (
              ''
            )}
          </Typography>
        </Grid>
      </Grid>
    </Typography>
  );
};

export default AttorneyForm;
